export const SOCKET_IO_URL = 'https://dl-match-overlay-nest-api.vicli.dev';

export const BASE_WIDTH = 1920;
export const BASE_HEIGHT = 1080;

export const TEAM_MAPPING = {
    'amber': [1, 2, 3, 4, 5, 6],
    'sapphire': [12, 11, 10, 9, 8, 7]
};
